<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents.html" xml:lang="en-US">
<div class="Basic-Text-Frame-1">
<p class="image-fl"><span class="a-head-italics"><img alt="birdonstem.tif" class="image" src="images/birdonstem_fmt.png" width="37%"/></span></p>
<p class="x1toc" id="toc_marker-6"><span class="a-head-italics" style="font-size:0.93em;">table of </span><br/>Contents<a id="x-contents-"></a></p><a id="x-contents-">
<p class="swoosh-toc"><img alt="633.jpg" class="image" src="images/633.jpg" width="10%"/></p>
</a><p class="TOC-chapter-titles"><a id="x-contents-"></a><a href="#/SeasonsWitchery#Introduction">Introduction</a></p>
<p class="TOC-chapter-titles"><a href="#/SeasonsWitchery1#Anchor">Chapter 1</a>: Midsummer/Summer Solstice</p>
<p class="TOC-chapter-titles"><a href="#/SeasonsWitchery2#Anchor-3">Chapter 2</a>: Lughnasadh/Lammas</p>
<p class="TOC-chapter-titles"><a href="#/SeasonsWitchery3#Anchor-4">Chapter 3</a>: Autumn Equinox/Mabon </p>
<p class="TOC-chapter-titles"><a href="#/SeasonsWitchery4#Anchor-5">Chapter 4</a>: Samhain/Halloween </p>
<p class="TOC-chapter-titles"><a href="#/SeasonsWitchery5#Anchor-6">Chapter 5</a>: Yule/Winter Solstice </p>
<p class="TOC-chapter-titles"><a href="#/SeasonsWitchery6#Anchor-7">Chapter 6</a>: Imbolc/Candlemas </p>
<p class="TOC-chapter-titles"><a href="#/SeasonsWitchery7#Anchor-8">Chapter 7</a>: Vernal Equinox/Ostara </p>
<p class="TOC-chapter-titles"><a href="#/SeasonsWitchery8#Anchor-9">Chapter 8</a>: Beltane </p>
<p class="TOC-chapter-titles"><a href="#/SeasonsWitchery9#Anchor-10">Afterword</a>: Reflections on the Past Year</p>
<p class="TOC-chapter-titles"><span href="#/Acks#Acknowledgments" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="TOC-chapter-titles"><a href="#/SeasonsWitchery10#Anchor-11">Appendix</a><span>: </span>Sabbat Correspondences </p>
<p class="TOC-chapter-titles"><a href="#/SeasonsWitchery11#Anchor-12">Glossary</a></p>
<p class="TOC-chapter-titles"><a href="#/SeasonsWitchery12#Anchor-13">Bibliography</a> </p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?5be081af